import React from 'react';
import { useSelector } from 'react-redux';

import { useTheme } from '../../hooks/useTheme';

const DealsTitleBanner = () => {
	const { banners: { Top } = {} } = useSelector((state) => state);

	const theme = useTheme('titleBanner');

	if (!Top) {
		return null;
	}

	const { Title, SubtitleOne } = Top[0] ?? {};

	if (!Title || !SubtitleOne) {
		return null;
	}

	return (
		<div
			className={`${theme.background} flex flex-col items-center justify-center p-4`}>
			<div className={`${theme.title} text-display-lg`}>{Title}</div>
			<div className={`${theme.text} text-title-lg`}>{SubtitleOne}</div>
		</div>
	);
};

export default DealsTitleBanner;
